<template>

    <div :class="[type==='agenda'? 'calendarAgenda card agenda' : 'calendarAgenda card']">
        <div class="cal">
            <DatePicker title-position="left" :first-day-of-week="2" v-model="dateNow"
                :masks="{ title: 'MMM YYYY', weekdays: 'WW' }" :attributes='attrs'
                :class="[type==='agenda'? 'myCustomAgenda' : '']" />
        </div>
        <div class="agenda">
            <div v-if="type==='agenda'" class="titleagenda text-red text-bold mb-1">
                <slot></slot>
            </div>
            <div class="text-blue text-bold mb-1">
                <slot></slot>
            </div>
            <div class="agendaCard mb-1"  v-for="agenda in list" :key="agenda.slug">
                <div class="date text-center text-bold">{{ new Date(agenda.event_start_date).getDate() }} {{ shortMonthName(new Date(agenda.event_start_date)) }}</div>
                <div class="titleAgenda" style="font-weight: 500;">{{ agenda.title }}</div>
            </div>
            <div v-if="!loading && list.length === 0">
              Belum ada agenda
            </div>
            <div v-if="loading">
              Memuat...
            </div>
        </div>
    </div>

</template>

<script>
import {
  DatePicker
} from 'v-calendar'
export default {
  data () {
    return {
      dateNow: new Date(),
      attrs: [{
        // key: 'today',
        dot: {
          style: {
            backgroundColor: '#ed1c24'
          },
          class: 'customDot'
        },
        dates: new Date()
      }],
      agendaList: null
    }
  },
  components: {
    DatePicker
  },
  props: ['type', 'list', 'loading'],
  watch: {
    dateNow () {
      this.$emit('dateselected', this.dateNow)
    }
  }
}
</script>

<style lang="scss" scoped>
    .calendarAgenda {
        // display: flex;
        height: 340px;
        display: grid;
        grid-template-columns: 3fr 4fr;

        @media only screen and (max-width: 600px) {
            grid-template-columns: 1fr;
            height: auto;
            padding: 1rem 0;
        }

        grid-gap: 1.5rem;
        padding: 1rem;

        &.agenda {
            height: auto;
              @media only screen and (max-width: 800px) {
                   grid-template-columns: 1fr;
              }
        }

        .agendaCard {
            display: grid;
            grid-template-columns: 1fr 6fr;
            background: #f0f4ff;
            padding: 10px;
            border-radius: 10px;
            align-items: center;
            grid-gap: 1rem;
        }

        .cal {
            @media only screen and (max-width: 600px) {
                display: none;
            }
        }

        .agenda {
            .text-blue {
                @media only screen and (max-width: 600px) {
                    display: none;
                }
            }

            .titleagenda {
                display: none;

                @media only screen and (max-width: 600px) {
                    display: block;
                }
            }
        }

    }

    .vc-container {
        border: none;
    }

    .card {
        @media only screen and (max-width: 600px) {
            background-color: transparent !important;
        }
    }
</style>
<style lang="scss">
    .vc-pane-container {
        font-family: 'Montserrat', sans-serif;

        .vc-pane-layout {
            .vc-pane {
                .vc-header {
                    .vc-title {
                        font-size: 14px !important;
                        color: $blue;
                        font-weight: bold;
                        margin-bottom: 1rem;
                    }
                }

                .vc-weeks {
                    min-width: 300px;
                    grid-row-gap: 6px;

                    .vc-weekday {
                        font-weight: normal;
                        color: $black;
                        // font-size: 12px;
                    }

                    .vc-day {
                        span {
                            // font-size: 12px;
                        }

                        .vc-highlights {
                            .vc-day-layer {
                                .vc-highlight {
                                    background-color: $blue !important;
                                    width: 30px;
                                    height: 30px;
                                }
                            }

                        }

                        .vc-dots {
                            .vc-dot.customDot {
                                position: absolute;
                                top: 4px;
                                right: 11px;
                                width: 4px;
                                height: 4px;
                            }
                        }
                    }
                }
            }
        }

        .vc-arrows-container {
            .vc-arrow {
                .vc-svg-icon {
                    width: 7px;
                }

                .vc-svg-icon path {
                    fill: $black;
                }
            }
        }
    }

    .myCustomAgenda {
        .vc-pane-layout {
            .vc-pane {

                .vc-weeks {
                    min-width: 400px;
                    grid-row-gap: 12px;
                }
            }
        }
    }
</style>
